<template>
<div class="about-page">
  <h2 class="about-header">About Pockets Full And Posing</h2>
  <div class ="about-info">
  <p>
    Do you desire deluxe designs but find yourself with  decimated doubloons? Wishing you could wear the wardrobe of the wealthy, but with a peasant price tag? Well, now you can! The makers of Creature Collab bring you Pockets Full And Posing: Royal Fashions For Regular Folk. Because everyone deserves to feel like nobility, no matter the count of coins in their coffers. 
  </p>
  </div>
</div>
</template>

<script>
export default {
  name: 'About'
}
</script>

